import { useEffect, useRef } from "react";
import { useApp } from "@/context/AppCtx";
import { useStrategist } from "@/hooks/useStrategist";

export function useAutoPilot() {
  const { 
    autoPilotEnabled, 
    navigateChartToMint, 
    algoSessionActive, 
    setAlgoSessionActive,
    chartAnalytics,
    tradingHalted
  } = useApp() as any;

  const { recommendations } = useStrategist();
  const lastSwitchTs = useRef(0);

  useEffect(() => {
    if (!autoPilotEnabled || tradingHalted) return;

    // 1. Check if we are already in a trade or arming for the current mint
    const scalperStatus = chartAnalytics?.scalperSnapshot?.status || chartAnalytics?.paperScalper?.status;
    const isBusy = scalperStatus === "in_trade" || scalperStatus === "arming";
    if (isBusy) return;

    // 2. Find high-quality target that isn't dead, rugged, or blacklisted
    const topRec = recommendations.find((r: any) => !r.isDead && !r.isRugged && r.mint && r.mint.toLowerCase() !== "dmxgg48pyynprxdbkxvtzs1kzojc6g6efme8jaoypump");
    if (!topRec) return;

    const currentMint = chartAnalytics?.mint;
    const now = Date.now();

    // 3. If no mint is selected, lock on immediately (0ms delay)
    if (!currentMint) {
      console.log(`[Auto-Pilot] Instant lock-on (no mint): ${topRec.coin || topRec.mint}`);
      navigateChartToMint(topRec.mint);
      lastSwitchTs.current = now;
      if (!algoSessionActive) setAlgoSessionActive(true);
      return;
    }

    // 4. If current mint differs from the top recommendation, move instantly
    if (topRec.mint !== currentMint) {
      const timeSinceLastSwitch = now - lastSwitchTs.current;
      const lastTradeAt = chartAnalytics.orderBookLastTradeAt as number | null;
      const hasRecentTrade = lastTradeAt != null && (now - lastTradeAt < 15_000);

      // Instant transition if silent or after minimal 3s stability window
      if (timeSinceLastSwitch >= 3000 || !hasRecentTrade) {
        console.log(`[Auto-Pilot] Moving instantly to next token: ${topRec.coin || topRec.mint}`);
        navigateChartToMint(topRec.mint);
        lastSwitchTs.current = now;
        if (!algoSessionActive) setAlgoSessionActive(true);
      }
    }
  }, [
    autoPilotEnabled, 
    recommendations, 
    chartAnalytics?.mint, 
    chartAnalytics?.scalperSnapshot?.status, 
    chartAnalytics?.paperScalper?.status,
    chartAnalytics?.orderBookLastTradeAt,
    algoSessionActive, 
    tradingHalted,
    navigateChartToMint,
    setAlgoSessionActive
  ]);
}

